var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 16C25 16.3042 24.8792 16.5959 24.6641 16.811C24.449 17.0261 24.1572 17.1469 23.8531 17.1469L10.5638 17.1469L15.488 22.0712C15.6906 22.2886 15.8009 22.5762 15.7957 22.8733C15.7904 23.1704 15.67 23.4539 15.4599 23.6641C15.2498 23.8742 14.9663 23.9946 14.6691 23.9998C14.372 24.0051 14.0844 23.8948 13.867 23.6922L6.98533 16.8105C6.77055 16.5955 6.6499 16.3039 6.6499 16C6.6499 15.6961 6.77055 15.4045 6.98533 15.1895L13.867 8.30783C14.0844 8.10523 14.372 7.99494 14.6691 8.00018C14.9663 8.00542 15.2498 8.1258 15.4599 8.33594C15.67 8.54608 15.7904 8.82958 15.7957 9.12671C15.8009 9.42385 15.6906 9.71142 15.488 9.92884L10.5638 14.8531L23.8531 14.8531C24.1572 14.8531 24.449 14.9739 24.6641 15.189C24.8792 15.4041 25 15.6958 25 16Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c6497e81af2ca45f9a72d9842547d6dd.svg";
export { ForwardRef as ReactComponent };